export const criticalListLeft = [
    { name: "Missing Title", value: 0 },
    { name: "Duplicate Title", value: 0 },
    { name: "Multiple Title", value: 0 },
    { name: "Missing Description", value: 0 },
    { name: "Duplicate Description", value: 0 },
    { name: "Multiple Description", value: 0 },
    { name: "Missing H1 Tag", value: 0 },
    { name: "Multiple H1 Tag", value: 0 },
    { name: "Missing Image Alt Text", value: 0 },
    { name: "Text compression", value: 0 },
    { name: "SEO friendly URL", value: 0 },
    { name: "Robots.txt", value: 0 },
    { name: "noindex", value: 0 },
    { name: "404 page", value: 0 },
  ];
  
  export const warningListLeft = [
    { name: "Title Too Short", value: 0 },
    { name: "Title Too Long", value: 0 },
    { name: "Description Too Short", value: 0 },
    { name: "Description Too Long", value: 6 },
    { name: "Image Format", value: 0 },
    { name: "Load Time", value: 0 },
    { name: "Page Size", value: 0 },
    { name: "Structured data", value: 0 },
    { name: "Meta viewport", value: 0 },
    { name: "Language", value: 0 },
    { name: "Favicon", value: 0 },
  ];
  
  export const noticesListLeft = [
    { name: "JavaScript defer", value: 0 },
    { name: "Dom Size", value: 0 },
    { name: "Character set", value: 0 },
    { name: "Sitemap", value: 0 },
    { name: "Content Length", value: 0 },
    { name: "Meta viewport", value: 0 },
    { name: "Text viewport", value: 0 },
    { name: "Text to HTML ratio", value: 0 },
    { name: "Inline CSS", value: 0 },
    { name: "In-page Links", value: 0 },
    { name: "Deprecated HTML", value: 0 },
  ];
  
  export const passedListLeft = [
    { name: "Title", value: 0 },
    { name: "Meta Description", value: 0 },
    { name: "Heading Tag", value: 0 },
    { name: "Content Keywords", value: 0 },
    { name: "Image Keywords", value: 0 },
    { name: "Text compression", value: 0 },
    { name: "Google Safe Browsing", value: 0 },
    { name: "SEO friendly URl", value: 0 },
    { name: "Robots.txt", value: 0 },
    { name: "noindex", value: 0 },
    { name: "indexed", value: 0 },
  ];